import { AnimationGroup } from '../AnimationGroup';
import { getElement, measure, mutate, getRanges, getNamedEffect, getEffectsData } from './common';
import fastdom from 'fastdom';
function getWebAnimationEffect(preset, animation, target, options) {
  if (preset) {
    let domApi;
    if (target instanceof HTMLElement) {
      domApi = {
        measure: measure(target),
        mutate: mutate(target)
      };
    }

    // validate duration is a number over 0
    if (animation.type === 'TimeAnimationOptions') {
      animation.duration = animation.duration || 1;
    }
    return preset.web ? preset.web(animation, domApi, options) : preset(animation, domApi, options);
  }
  return [];
}
function getWebAnimation(target, animationOptions, trigger, options, ownerDocument) {
  const element = target instanceof HTMLElement ? target : getElement(target, ownerDocument);
  if ((trigger == null ? void 0 : trigger.trigger) === 'pointer-move') {
    let effectOptions = animationOptions;
    if (animationOptions.customEffect) {
      effectOptions = {
        ...animationOptions,
        namedEffect: {
          id: '',
          type: 'CustomMouse'
        }
      };
    }

    // TODO: need to fix the type here, currently lying about the returned type to be WebAnimationEffectFactory instead of MouseAnimationFactoryCreate
    const mouseAnimationPreset = getNamedEffect(effectOptions);
    const mouseAnimationFactory = getWebAnimationEffect(mouseAnimationPreset, animationOptions, element, options);
    return mouseAnimationFactory(element);
  }

  // get the preset for the given animation options
  const namedEffect = getNamedEffect(animationOptions);
  const animationsData = getWebAnimationEffect(namedEffect, animationOptions, element, options);
  const data = getEffectsData(animationsData, animationOptions.effectId);
  let timeline;
  const isViewProgress = (trigger == null ? void 0 : trigger.trigger) === 'view-progress';

  // if this is a ScrubAnimation with view-progress trigger and the browser supports the ViewTimeline API
  if (isViewProgress && window.ViewTimeline) {
    // generate the timeline object
    // @ts-expect-error
    timeline = new ViewTimeline({
      subject: trigger.element || getElement(trigger.componentId)
    });
  }

  // generate an Animation object for each data object
  const animations = data.map(_ref => {
    let {
      effect,
      options: effectOptions,
      id,
      part
    } = _ref;
    const effectTarget = part ? element == null ? void 0 : element.querySelector(`[data-motion-part~="${part}"]`) // maybe add ~ here as well
    : element;
    const keyframeEffect = new KeyframeEffect(effectTarget || null, [], effectOptions);

    // set the keyframes for the KeyframeEffect after measurements and mutations
    fastdom.mutate(() => {
      if ('timing' in effect) {
        keyframeEffect.updateTiming(effect.timing);
      }
      keyframeEffect.setKeyframes(effect.keyframes);
    });
    const animation = isViewProgress && timeline ? new Animation(keyframeEffect, timeline) : new Animation(keyframeEffect);

    // if this is a ScrubAnimation with view-progress trigger and the browser supports the ViewTimeline API
    if (isViewProgress) {
      if (timeline) {
        // set the ranges for the animation after measurements and mutations
        fastdom.mutate(() => {
          const {
            start,
            end
          } = getRanges(effect);
          // @ts-expect-error
          animation.rangeStart = start;
          // @ts-expect-error
          animation.rangeEnd = end;
          animation.play();
        });
      } else {
        const {
          startOffset,
          endOffset
        } = animationOptions;

        // set the ranges for the animation after measurements and mutations
        fastdom.mutate(() => {
          var _offset, _offset2;
          const startOffsetToWrite = effect.startOffset || startOffset;
          const endOffsetToWrite = effect.endOffset || endOffset;
          Object.assign(animation, {
            start: {
              name: startOffsetToWrite.name,
              offset: (_offset = startOffsetToWrite.offset) == null ? void 0 : _offset.value,
              add: effect.startOffsetAdd
            },
            end: {
              name: endOffsetToWrite.name,
              offset: (_offset2 = endOffsetToWrite.offset) == null ? void 0 : _offset2.value,
              add: effect.endOffsetAdd
            }
          });
        });
      }
    }
    if (id) {
      animation.id = id;
    }
    return animation;
  });

  // create an AnimationGroup with the generate animations
  return new AnimationGroup(animations, {
    ...animationOptions,
    trigger: {
      ...(trigger || {})
    },
    // make sure the group is ready after all animation targets are measured and mutated
    measured: new Promise(resolve => fastdom.mutate(resolve))
  });
}
export { getWebAnimation };
//# sourceMappingURL=webAnimations.js.map